
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'long_arrow_alt_left',
    },
    url: {
      type: String,
      default: '#',
    },
    external: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    buttonId: {
      type: String,
    },
    buttonClass: {
      type: String,
    },
  },
  computed: {
    hasIcon() {
      return this.icon && this.icon !== 'none' && this.icon !== null
    },

    isRightIcon() {
      const iconNames = [
        'angle_right',
        'chevron_right',
        'arrow_alt_to_botom',
        'external_link',
        'long_arrow_alt_right',
      ]
      return iconNames.includes(this.icon)
    },
    className() {
      return this.hasIcon
        ? 'button-link button-link-icon button-link-' + this.color
        : 'button-link'
    },
  },
}
